import { includes } from 'lodash';
import { translation } from '@/plugins/i18n';
import { isEmptyVal } from '@/utils';

export const checkAreaCodeLength = (search = '') => {
  const searchLength = search.length;

  if (searchLength !== 3) {
    return translation('billing.pbx.search_area_code_length');
  }

  return '';
};

export const checkVanitySuffixLength = (search = '') => {
  const searchLength = search.length;

  if (searchLength < 4 || searchLength > 7) {
    return translation('billing.pbx.search_vanity_length');
  }

  return '';
};

export const checkPortNumber = (portNumber = '', checkedNumberList = [], originValue = "") => {
  if (isEmptyVal(originValue)) {
    return translation('billing.pbx.port_number.required');
  }

  if (portNumber.length !== 10) {
    return translation('billing.pbx.port_number.must_10_digits');
  }

  if (includes(checkedNumberList, portNumber)) {
    return translation('billing.pbx.port_number.repeat');
  }

  return '';
};
